import React from 'react';

const ContactInfo = () => {
  return (
    <div className="w-full md:w-1/2 mx-auto px-6 py-10 after:content-[''] after:block after:w-48 after:h-[1px] after:bg-royal-gold-300 after:mx-auto after:mt-16 after:mb-2">
      <h2 className="text-4xl font-cursive font-bold text-center text-beast-brown-800 mb-6">Contacto</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="text-center">
          <h3 className="text-2xl font-medium mb-4 text-beast-brown-800">Bella</h3>
          <div className="space-y-2">
            <p className="text-beast-brown-700">Teléfono: <a href="tel:+34600840789" className="text-royal-gold-600 hover:text-royal-gold-700 font-medium">111 111 111</a></p>
            <p className="text-beast-brown-700">Email: <a href="mailto:bella@example.com" className="text-royal-gold-600 hover:text-royal-gold-700 font-medium">bella@bella.com</a></p>
          </div>
        </div>
        <div className="text-center">
          <h3 className="text-2xl font-medium mb-4 text-beast-brown-800">Bestia</h3>
          <div className="space-y-2">
            <p className="text-beast-brown-700">Teléfono: <a href="tel:+34644108231" className="text-royal-gold-600 hover:text-royal-gold-700 font-medium">000 000 000</a></p>
            <p className="text-beast-brown-700">Email: <a href="mailto:bestia@bestia.com" className="text-royal-gold-600 hover:text-royal-gold-700 font-medium">bestia@bestia.com</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo; 